var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-container",class:{ 'pie-chart': _vm.isPieChart }},[_c('highcharts',{ref:"chart",attrs:{"options":_vm.chartOptions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }